"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.half = exports.tiny = void 0;

var _theme = require("../../styles/theme");

var tiny = "\n  margin-top: ".concat(_theme.leading.third, ";\n");
exports.tiny = tiny;
var half = "\n  margin-top: ".concat(_theme.leading.half, ";\n");
exports.half = half;